import { render } from "./Breadcrump.vue?vue&type=template&id=0dfe6dbe&scoped=true&lang=true"
import script from "./Breadcrump.vue?vue&type=script&lang=js"
export * from "./Breadcrump.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-0dfe6dbe"

export default script